import { createFileRoute } from '@tanstack/react-router';
import { DocumentDeepLinkView } from '@/components/DocumentDeepLinkView';

export const Route = createFileRoute('/_auth/documents/$documentId')({
  component: DocumentDeepLinkRoute,
});

function DocumentDeepLinkRoute() {
  const { documentId } = Route.useParams();
  return <DocumentDeepLinkView documentId={documentId} />;
}
